import {convertFromHtmlToDraftJs} from './HtmlToDraftJsConverter';
import {convertFromDraftJsToHtml} from './DraftJsToHtmlConverter';

type UseDraftJsHtmlConversionProps = {
	initialDraftJsContent: string;
	onDraftJsChanged?: (draftJsContent: string) => void;
};

type UseDraftJsHtmlConversionReturn = {
	initialHtml: string;
	convertHtmlToDraftJs: (htmlContent: string) => void;
};
export const useDraftJsHtmlConversion = ({
	initialDraftJsContent,
	onDraftJsChanged,
}: UseDraftJsHtmlConversionProps): UseDraftJsHtmlConversionReturn => {
	const initialHtml = convertFromDraftJsToHtml(initialDraftJsContent);
	const convertHtmlToDraftJs = (htmlContent: string) => {
		const draftJsContent = convertFromHtmlToDraftJs(htmlContent);
		if (onDraftJsChanged) {
			onDraftJsChanged(draftJsContent);
		}
	};

	return {initialHtml, convertHtmlToDraftJs};
};
